import { FormStep, IFormModel } from "../formModels";
import {
  IAboutYouFormInformationModel,
  IMainAndYPFormInformationModel,
} from "../formModels/AboutYouFormModel";
import {
  EligibilitySteps,
  JoiningType,
} from "../formModels/EligibilityFormModel";
import { IOnlineApplication } from "../services/online-application.types";
import {
  getAboutYouData,
  getCourseData,
  getCreditData,
  getHeadshotData,
  getJoiningAsData,
  getRecommendationData,
  getReviewData,
  getCurrentMemberData,
} from "./map-online-application-sections";

const mapOnlineApplication = (
  onlineApplication: IOnlineApplication
): IFormModel => ({
  [FormStep.Eligibility]: {
    [EligibilitySteps.JoiningAs]: {
      joiningAs: getJoiningAsData(onlineApplication),
    },
    [EligibilitySteps.AdditionalInformation]: {
      [JoiningType.Experienced]: getCreditData(onlineApplication),
      [JoiningType.Training]: getCourseData(onlineApplication),
      [JoiningType.Recommendation]: getRecommendationData(onlineApplication),
    },
  },
  [FormStep.AboutYou]: {
    photoUploadForm: getHeadshotData(onlineApplication),
    aboutYouInformationForm: getAboutYouData(
      onlineApplication
    ) as IMainAndYPFormInformationModel,
  },
  [FormStep.AboutYouMPCurrentMember]: getCurrentMemberData(onlineApplication),
  [FormStep.AboutYouYP]: {
    photoUploadForm: getHeadshotData(onlineApplication),
    aboutYouInformationForm: getAboutYouData(
      onlineApplication,
      true
    ) as IAboutYouFormInformationModel,
  },
  [FormStep.Review]: getReviewData(onlineApplication),
});

export default mapOnlineApplication;
